import { useContacts } from '@entities/contacts';
import { useContactsSelecting } from '@entities/contacts/model.ts';
import type React from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { Add, ArrowShortLeft } from '@shared/assets';
import { formatPhoneNumber, isPhoneNumber } from '@shared/helpers';
import type { ContactItem } from '@shared/types/contacts';
import { IconButton, ListBody, PageHead, PageTitle, TextButton } from '@shared/ui';
import { Loader } from '@src/library/components/common';
import * as st from './style.module.scss';

export const Contacts: React.FC = () => {
  const { addNewContact, updateCoachContact, isLoading, setSelectedContacts } = useContacts();
  const { selectedContactsIds, resetSelectedContactsIds } = useContactsSelecting();
  const navigate = useNavigate();
  const location = useLocation();

  const isAddPage = location.pathname.split('/').at(-1) === 'add';
  const isEditPage = location.pathname.split('/').at(-1) === 'edit';

  const resetLocalStorage = () => {
    localStorage.removeItem('contactValue');
    localStorage.removeItem('editContact');
  };

  const handleSubmitContact = async () => {
    const localContactData = localStorage.getItem('contactValue');
    if (localContactData) {
      const contactData: ContactItem = JSON.parse(localContactData);
      if (isPhoneNumber(contactData.value)) {
        contactData.value = formatPhoneNumber(contactData.value);
      }

      try {
        if (isAddPage) {
          const { id, ...newContactData } = contactData;
          await addNewContact(newContactData);
        }
        if (isEditPage) {
          await updateCoachContact(contactData);
        }
        resetLocalStorage();
        navigate(-1);
      } catch (e) {
        console.error(e);
      }
    }
  };

  const handleClickSubmit = async () => {
    if (!isAddPage && !isEditPage) {
      setSelectedContacts(selectedContactsIds);
      navigate(-1);
    } else {
      await handleSubmitContact();
    }
  };

  const handleClickAdd = () => {
    navigate('add');
    resetLocalStorage();
  };

  const handleClickBack = () => {
    resetLocalStorage();
    navigate(-1);
    resetSelectedContactsIds([]);
  };

  return (
    <>
      <PageTitle title="Контакты" />
      <PageHead
        Left={
          <IconButton variant="dark" onClick={handleClickBack}>
            <ArrowShortLeft />
          </IconButton>
        }
        Right={
          <>
            {!isAddPage && !isEditPage && (
              <IconButton variant="dark" onClick={handleClickAdd} title="Создать новый контакт">
                <Add />
              </IconButton>
            )}
            <TextButton type="button" onClick={handleClickSubmit}>
              Готово
            </TextButton>
          </>
        }
      />
      <ListBody className={st.listBody}>{isLoading ? <Loader /> : <Outlet />}</ListBody>
    </>
  );
};
